import React from 'react';
import styled from 'styled-components';

import { DemoHeaderBanner } from '@powdr/components/demos';
import {
  Components, ThemeProps as Prop,
  FontFamily,
  FontSize,
} from '@powdr/constants';
import { themeUtil, getFontStyles } from '@powdr/utils';

const CPNT = Components.HEADER;

const JumpButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  ${() => getFontStyles(FontFamily.SECONDARY_FONT, FontSize.REG30, undefined, undefined)};
  line-height: ${FontSize.REG30};
  color: ${() => themeUtil(Prop.BTN_TXT, CPNT)};
  background-color: ${() => themeUtil(Prop.BTN_BG, CPNT)};
  transition: all 0.25s ease-in-out;
  border-bottom: 1px solid ${() => themeUtil(Prop.BORDER, CPNT)};

  &:hover {
    color: ${() => themeUtil(Prop.BTN_TXT_HOVER, CPNT)};
    background-color: ${() => themeUtil(Prop.BTN_BG_HOVER, CPNT)};
  }
`;

export const DemoPageJump = () => (
  <DemoHeaderBanner>
    <JumpButton href="#">Jump to Top of Page</JumpButton>
  </DemoHeaderBanner>

);

DemoPageJump.propTypes = {};
